import { h, Component, Prop, State } from '@stencil/core';
import ProjectManager from '../root/project-manager';
declare const Reveal;


@Component({
  tag: 'tip-presentation-root',
  styleUrl: 'presentation-root.css'
})

export class PresentationRoot {
  @Prop() presentationDate: string = '';
  @Prop() presentationType: string = '';
  @Prop() baseUrl: string;
  @Prop() layers: string;
  @Prop() logoUrl: string;
  @Prop() revision: string;
  @Prop() projectManager: any = new ProjectManager();
  @Prop() projects: any[];

  @Prop() standardFields: string[] = ['start_terminus', 'end_terminus',
    'fiscal_year', 'lead_agency', 'total_cost']
  @Prop() withoutHistoryFields: string[] = ['start_terminus', 'end_terminus',
    'fiscal_year', 'lead_agency', 'total_cost', 'advanced_construction']

  ignoreFields: string[] = [
    'date_notified', 'date_added', 'date_approved', 'date_technical_meeting',
    'date_policy_meeting', 'comments'
  ];

  @State() features: any[] = [];

  async componentWillLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    this.baseUrl = urlParams.get('baseUrl');
    this.layers = urlParams.get('layers');
    this.revision = urlParams.get('revision');
    this.presentationDate = urlParams.get('date');
    this.presentationType = urlParams.get('type');

    let layers = await Promise.all(
      this.layers.split(',')
        .map((layer) => this.fetchJSON(
          `${this.baseUrl}/data/${layer}.geojson?rev=${this.revision}`)));
    this.features = [];
    for (let layer of layers) this.features.push(...layer.features);
    this.projects = this.projectManager.createProjects(this.features);
  }

  componentDidLoad() {
    window.setTimeout(() => Reveal.initialize(), 0);
  }

  async fetchJSON(url: string) {
    let res = await fetch(url);
    return await res.json();
  }

  renderTitle() {
    return (this.presentationType === 'policy_meeting' ?
      'Policy Meeting' : 'Technical Meeting');
  }

  renderSubtitle() {
    let date = new Date(this.presentationDate);
    return date.toLocaleDateString();
  }

  renderHeaderRow(attributeColumns) {
    let glColumns = Array.from(document.querySelectorAll('gl-table-column'));
    let headerCells = attributeColumns.map((attr) => {
      let glColumn = glColumns.find((glCol) => {
        return glCol['attribute'] === attr
      })
      return <th>{glColumn['label']}</th>
    })
    return <tr><th></th>{headerCells}</tr>
  }

  renderComments(project) {
    return <p>{project.getLatestAttribute('comments')}</p>
  }

  renderDescription(project) {
    return <p>{'Description: ' + project.getLatestAttribute('description')}</p>
  }

  renderDefaultTable(project) {
    let glColumns = Array.from(document.querySelectorAll('gl-table-column'))
    return <gl-table features={[project.getLatestFeature()]}>
      {this.withoutHistoryFields.map((attr) => {
        let glCol = glColumns.find((col) => {
          return col['attribute'] === attr
        })
        return (
          <gl-table-column
            attribute={attr}
            label={glCol['label']}
            format={glCol['format']}
            component={glCol['component']}
            sortable={false}
            cell-class-attribute={glCol['cellClassAttribute']}>
          </gl-table-column>
        )
      })}
    </gl-table>
  }
  renderTable(renderAttributes, _changeFields, project) {
    let glColumns = Array.from(document.querySelectorAll('gl-table-column'));
    let table =
      <gl-table features={project.getPresentationRows(this.presentationType, this.presentationDate)}
        rowClassAttribute='rowClassAttribute'>

        {renderAttributes.map((attr) => {
          let glCol = glColumns.find((col) => {
            return col['attribute'] === attr
          })

          return (
            <gl-table-column
              attribute={attr}
              label={glCol['label']}
              format={glCol['format']}
              component={glCol['component']}
              sortable={false}
              cell-class-attribute={glCol['cellClassAttribute']}>
            </gl-table-column>
          )
        })}

      </gl-table>
    return table
  }

  renderSlides(project) {
    let changeFields = project.getChangeFields().filter((e) => {
      return this.ignoreFields.indexOf(e) === -1;
    });
    let renderAttribute = this.standardFields.concat(changeFields);
    renderAttribute.unshift(
      (this.presentationType === 'policy_meeting' ?
        'date_policy_meeting' : 'date_technical_meeting')
    );

    renderAttribute = renderAttribute.filter((e, i) => {
      return renderAttribute.indexOf(e) >= i
    })

    if (project.featureCount() > 1) {
      return (
        <section>
          <h3>{project.getLatestAttribute('project_title') +
            ': ' + project.getLatestAttribute('project_id')}</h3>
          {this.renderTable(renderAttribute, changeFields, project)}
          {this.renderDescription(project)}
          {this.renderComments(project)}
        </section>
      )
    } else {
      return (
        <section>
          <h3>{project.getLatestAttribute('project_title') +
            ': ' + project.getLatestAttribute('project_id')}</h3>
          {this.renderDefaultTable(project)}
          {this.renderDescription(project)}
          {this.renderComments(project)}
        </section>
      )
    }
  }

  render() {
    let filteredProjects = this.projects.filter((project) => {
      let date = project.getLatestAttribute(
        `date_${this.presentationType}`)
      if (date) {
        return date.indexOf(this.presentationDate) > -1;
      };
    })

    filteredProjects.sort(function (a, b) {
      let textA = a.getLatestAttribute('project_id');
      let textB = b.getLatestAttribute('project_id');
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    })

    let amendments = filteredProjects.filter((project) => {
      return project.getLatestAttribute('change_type') === 'Amendment'
    })
    let modifications = filteredProjects.filter((project) => {
      return project.getLatestAttribute('change_type') === 'Modification'
    })

    let data = (
      <div class="reveal" style={{ height: '100%', width: '100%' }}>
        <div class="slides">
          <section>
            <h2>{this.renderTitle()}</h2>
            <h5>{this.renderSubtitle()}</h5>
            <img class='logo' src={this.logoUrl}
              alt='Champaign County Regional Planning Commission'></img>
          </section>
          <section>
            <h2>Amendments</h2>
          </section>
          {amendments.map((project) => {
            return (
              this.renderSlides(project)
            )
          })}
          <section>
            <h2>Modifications</h2>
          </section>
          {modifications.map((project) => {
            return (
              this.renderSlides(project)
            )
          })}
        </div>
      </div>
    )
    return data
  }
}
